import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/auth/slice';
import campaignsReducer from './slices/campaigns/slice';
import dashboardReducer from './slices/dashboard/slice';
import notificationReducer from './slices/notification/slice';
import newsletterReducer from './slices/newsletter/slice';
import proAccountsReducer from './slices/proAccounts/slice';
import { downloadProAccountList } from './slices/proAccounts/actions';
import portfolioReducer from './slices/portfolio/slice';
import listIconReducer from './slices/listIcon/slice';
import referralTrackingReducer from './slices/referralTracker/slice';
import { downloadReferralTrackerList } from './slices/referralTracker/actions';
import accountSettingsReducer from './slices/accountSettings/slice';
import { setupInterceptors } from '../api';
import { accountSettingsListener } from './slices/accountSettings/listener';
import { uploadContentListener } from './slices/listIcon/listener';

const rootReducer = combineReducers({
    auth: authReducer,
    campaigns: campaignsReducer,
    dashboard: dashboardReducer,
    newsletter: newsletterReducer,
    notifications: notificationReducer,
    proAccounts: proAccountsReducer,
    portfolio: portfolioReducer,
    listIcon: listIconReducer,
    referralTracker: referralTrackingReducer,
    accountSettings: accountSettingsReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          downloadReferralTrackerList.fulfilled.type, 
          downloadProAccountList.fulfilled.type,
          'listIcon/setUploadFormState', // Ignore for File object in payload
          'listIcon/setUploadAbortController', // Ignore for AbortController in payload
        ],
        ignoredPaths: [
            'listIcon.uploadFormState.file', // Ignore File object in state
            'listIcon.uploadAbortController', // Ignore AbortController in state
        ],
      },
    }).prepend(accountSettingsListener.middleware, uploadContentListener.middleware),
});

setupInterceptors(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
